import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { Box, IconButton } from "@similarweb/ui-components";

import { NoPrintContainerStyles } from "app/components/layout/NoPrintContainer";
import { StyledPrimaryTitle } from "pro-features/styled components/StyledBoxTitle/src/StyledBoxTitle";
import { FlexColumn, FlexRow, CenteredFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { StyledLink } from "pro-features/styled components/StyledLink/src/StyledLink";

export const StyledBox = styled(Box)<{
    minWidth?: number | string;
    minHeight?: number | string;
    maxWidth?: number | string;
    height?: string;
}>`
    height: ${({ height }) => height ?? "unset"};
    width: unset;
    min-width: ${({ minWidth = 0 }) => (minWidth && typeof minWidth === "number" ? `${minWidth}px` : minWidth)};
    ${({ maxWidth }) =>
        maxWidth &&
        css`
            max-width: ${typeof maxWidth === "number" ? `${maxWidth}px` : maxWidth};
        `};
    min-height: ${({ minHeight = 0 }) => (minHeight && typeof minHeight === "number" ? `${minHeight}px` : minHeight)};
`;

export const WidgetHeaderContainer = styled(FlexColumn)<{
    withBorder?: boolean;
    hasSubtitleFilters?: boolean;
    hasDescriptionText?: boolean;
    $headerHeight?: number;
}>`
    box-sizing: border-box;
    padding: 20px 24px;
    gap: 20px;
    ${({ withBorder }) =>
        withBorder &&
        css`
            border-bottom: 1px solid ${colorsPalettes.carbon[50]};
        `};
    height: ${({ hasSubtitleFilters, hasDescriptionText, $headerHeight = 64 }) => {
        let height = $headerHeight;
        if (hasSubtitleFilters) {
            height += 24;
        }
        if (hasDescriptionText) {
            height += 36;
        }
        return `${height}px`;
    }};
`;

export const WidgetMetadataContainer = styled(FlexColumn)<{ hideSubtitles?: boolean }>`
    white-space: nowrap;
    flex-grow: 1;

    ${({ hideSubtitles }) => hideSubtitles && "justify-content: center;"};
`;

export const WidgetActionsContainer = styled(CenteredFlexRow)`
    gap: 12px;
    .swichers-container {
        margin-right: 0;
    }
    ${NoPrintContainerStyles};
`;

export const WidgetActionsItemWrapper = styled(WidgetActionsContainer)<{ width?: string }>`
    ${({ width }) => width && `width: ${width}`};
    position: relative;
    overflow: visible;
`;

export const WidgetOnOffWrapper = styled(WidgetActionsItemWrapper)`
    margin-top: 4px;
`;

export const WidgetActionsTitle = styled(WidgetActionsItemWrapper)`
    ${setFontVariant("input2", colorsPalettes.carbon[500])};
`;

export const WidgetHeaderSwitcherContainer = styled.div`
    height: 40px;
`;

export const ButtonWrapper = styled.div`
    width: 40px;
    height: 40px;
    .DownloadButtonWrapper {
        margin-right: 0;
        left: auto;
    }
`;

export const ButtonsWrapper = styled(FlexRow)`
    gap: 4px;
`;

export const WidgetTitle = styled(StyledPrimaryTitle)<{ hideSubtitles?: boolean }>`
    align-items: center;
    height: ${({ hideSubtitles }) => (hideSubtitles ? "auto" : "24px")};
    margin-bottom: ${({ hideSubtitles }) => (hideSubtitles ? "0" : "8px")};
    ${({ hideSubtitles }) => hideSubtitles && "padding-bottom: 8px;"};
    white-space: nowrap;
`;

export const LoaderWrapper = styled.div<{ usePercentageWidth?: boolean }>`
    display: flex;
    align-items: center;
    padding: 20px;
    box-sizing: border-box;
    ${({ usePercentageWidth }) =>
        usePercentageWidth &&
        `
            width: 100%;
            justify-content: center;
        `};
`;

export const BodyWrapper = styled.div<{
    bodyMinHeight: number;
    noData: boolean;
    bodyHeight?: string;
    hasFooter?: boolean;
}>`
    min-height: ${({ bodyMinHeight = 0 }) => `${bodyMinHeight}px`};
    height: ${({ bodyHeight }) => bodyHeight ?? "100%"};
    ${({ hasFooter }) =>
        hasFooter === false &&
        `
            padding-bottom: 2px;
        `};
    ${({ noData }) =>
        noData &&
        css`
            display: flex;
            justify-content: center;
            min-height: 288px;
        `};
`;

export const WidgetFooterContainer = styled(FlexRow)`
    justify-content: flex-end;
    align-items: center;
    box-sizing: border-box;
    padding-right: 8px;
    height: 51px;
    border-top: 1px solid ${colorsPalettes.carbon[50]};
`;

export const WidgetFooterButtonContainer = styled(StyledLink)`
    font-size: 14px;
`;

export const WidgetWrapper = styled(FlexColumn)<{ $height?: string }>`
    height: ${({ $height }) => $height ?? "100%"};
`;

export const CloseButton = styled(IconButton)`
    padding-bottom: 8px;
`;
